import { __assign } from './../external_lib/tslib/tslib.es6.js';
import React__default, { useRef, useState, useEffect } from 'react';
import Typography from '../Atoms/Typography.js';
import classNames from './../external_lib/classnames/index.js';
import Button from '../Atoms/Button.js';
import CalendarIcon from '../assets/icons/calendar.icon.js';
import LeftOutlined from './../external_lib/@ant-design/icons/LeftOutlined.js';
import RightOutlined from './../external_lib/@ant-design/icons/RightOutlined.js';
import Tabs from '../Atoms/Tabs.js';
import Tab from '../Components/Atoms/Tabs/Web/tab.component.js';
import Capsule from '../Atoms/Capsule.js';
import { FulfillmentType } from '../Enums/fulfillment_type.enum.js';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Icon from './../external_lib/@ant-design/icons/es/components/Icon.js';

dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
function OrderNowLater(_a) {
    var _b, _c, _d;
    var classes = _a.classes, orderLaterData = _a.orderLaterData, onContinue = _a.onContinue, variant = _a.variant, startDate = _a.startDate, endDate = _a.endDate, orderNowOffsetTime = _a.orderNowOffsetTime, isOrderNowDisabled = _a.isOrderNowDisabled, isOrderLaterDisabled = _a.isOrderLaterDisabled, isRiderNotAvailable = _a.isRiderNotAvailable, selectedOrderTimeData = _a.selectedOrderTimeData, storeTimings = _a.storeTimings;
    var t = useTranslation().t;
    var ref = useRef(null);
    var _e = useState(null), selectedTab = _e[0], setSelectedTab = _e[1];
    var _f = useState(null), selectedDate = _f[0], setSelectedDate = _f[1];
    var _g = useState(null), selectedTime = _g[0], setSelectedTime = _g[1];
    var _h = useState(true), showArrows = _h[0], setShowArrows = _h[1];
    var _j = useState([]), allDates = _j[0], setAllDates = _j[1];
    var _k = useState(isOrderNowDisabled), _isOrderNowDisabled = _k[0], _setIsOrderNowDisabled = _k[1];
    var handleSelectDate = function (date) {
        setSelectedDate(date);
        setSelectedTime(null);
    };
    useEffect(function () {
        if (startDate && endDate && orderLaterData) {
            var totalDays = dayjs(endDate).diff(startDate, 'days') + 1;
            var _allDates = Array(totalDays)
                .fill(0)
                .reduce(function (result, val, index) {
                var expectedDate = dayjs().add(index, 'day');
                var dayFormat = orderLaterData[expectedDate.format('ddd')];
                if (dayFormat) {
                    result.push(expectedDate);
                }
                return result;
            }, []);
            // max 30 days calendar only
            if (!(selectedOrderTimeData === null || selectedOrderTimeData === void 0 ? void 0 : selectedOrderTimeData.timeSlot)) {
                setSelectedDate(_allDates === null || _allDates === void 0 ? void 0 : _allDates[0]);
            }
            setAllDates(_allDates.slice(0, 30));
        }
    }, [startDate, endDate, orderLaterData]);
    var scrollToActiveDateOnMount = function () {
        var activeDate = document.getElementById('active-date');
        if (activeDate) {
            handleScroll(activeDate.offsetLeft - 200);
        }
    };
    var handleScroll = function (scrollOffset) {
        ref.current.scrollLeft += scrollOffset;
    };
    useEffect(function () {
        if (selectedOrderTimeData && (selectedOrderTimeData === null || selectedOrderTimeData === void 0 ? void 0 : selectedOrderTimeData.timeSlot)) {
            setSelectedTab('orderLater');
            setSelectedDate(dayjs(selectedOrderTimeData.date));
            setSelectedTime(selectedOrderTimeData.timeSlot);
            if (allDates) {
                scrollToActiveDateOnMount();
            }
        }
        else if (!isRiderNotAvailable) {
            setSelectedTab('orderNow');
        }
        else {
            setSelectedTab(null);
        }
    }, [selectedOrderTimeData, allDates]);
    var CalendarIcon$1 = function (props) { return React__default.createElement(Icon, __assign({ component: CalendarIcon }, props)); };
    var isContinueDisabled = function () {
        if (selectedTab === 'orderNow') {
            if (_isOrderNowDisabled || isRiderNotAvailable) {
                return true;
            }
        }
        else {
            if (!selectedTime || !selectedDate) {
                return true;
            }
        }
        return false;
    };
    useEffect(function () {
        if (isRiderNotAvailable) {
            setSelectedTab(null);
        }
    }, [isRiderNotAvailable]);
    var onContinueButton = function () {
        var payload = {
            type: null,
            date: (selectedDate || dayjs()).format('YYYY-MM-DD'),
            timeSlot: selectedTab === 'orderNow' ? null : selectedTime,
            orderNowOffsetTime: orderNowOffsetTime
        };
        if (variant === FulfillmentType.delivery) {
            payload.type = FulfillmentType.delivery;
        }
        else {
            payload.type = FulfillmentType.pickup;
        }
        onContinue === null || onContinue === void 0 ? void 0 : onContinue(payload);
    };
    var isOverflowing = function () {
        var _a, _b;
        return ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) > ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.offsetWidth);
    };
    useEffect(function () {
        setShowArrows(isOverflowing());
    }, [selectedTab]);
    useEffect(function () {
        if (!storeTimings)
            return;
        if (!isOrderNowDisabled) {
            var isAvailableForOrderingNow = isOrderNowAvailable(orderNowOffsetTime, storeTimings);
            if (!isAvailableForOrderingNow) {
                _setIsOrderNowDisabled(true);
            }
            else {
                _setIsOrderNowDisabled(false);
            }
        }
    }, [storeTimings, orderNowOffsetTime, isOrderNowDisabled]);
    var isOrderNowAvailable = function (offset, storeTimings) {
        var storeOpeningTime = dayjs(storeTimings.opening_time, 'hh:mm:ss');
        var storeClosingTime = dayjs(storeTimings.closing_time, 'hh:mm:ss');
        var currentDateTime = dayjs();
        return currentDateTime.isBetween(storeOpeningTime, storeClosingTime);
    };
    var filterOutInvalidTimeSlots = function (timeSlots) {
        if (selectedDate && timeSlots) {
            var todayWithOffset_1 = dayjs().add(orderNowOffsetTime, 'minutes');
            var currentTime = dayjs();
            if (currentTime.isSameOrBefore(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('YYYY-MM-DD'), 'day')) {
                // day.js object is the same as the other supplied date-time.
                var filteredTimeSlots = timeSlots === null || timeSlots === void 0 ? void 0 : timeSlots.filter(function (timeSlot) {
                    var timeSlotEnd = dayjs("".concat(selectedDate.format('YYYY-MM-DD'), " ").concat(timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.end_time), 'YYYY-MM-DD HH:mm');
                    return todayWithOffset_1.isBefore(timeSlotEnd);
                });
                return filteredTimeSlots;
            }
        }
        return timeSlots;
    };
    var activeMorningSlots = filterOutInvalidTimeSlots(((_b = orderLaterData === null || orderLaterData === void 0 ? void 0 : orderLaterData[(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('ddd')) || '']) === null || _b === void 0 ? void 0 : _b.morning_slots) || []);
    var activeAfternoonSlots = filterOutInvalidTimeSlots(((_c = orderLaterData === null || orderLaterData === void 0 ? void 0 : orderLaterData[(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('ddd')) || '']) === null || _c === void 0 ? void 0 : _c.afternoon_slots) || []);
    var activeEveningSlots = filterOutInvalidTimeSlots(((_d = orderLaterData === null || orderLaterData === void 0 ? void 0 : orderLaterData[(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('ddd')) || '']) === null || _d === void 0 ? void 0 : _d.evening_slots) || []);
    return (React__default.createElement("div", { className: classNames('order-now-later', classes) },
        React__default.createElement("div", { className: "order-now-later__tabs-wrapper" },
            !_isOrderNowDisabled ? (React__default.createElement("div", { className: classNames('order-now__tab', {
                    'order-now-later__tab--selected': selectedTab === 'orderNow',
                    'order-now__tab--disabled': isRiderNotAvailable
                }), onClick: function () { return setSelectedTab('orderNow'); } },
                React__default.createElement("div", null,
                    React__default.createElement(Typography, { classes: "order-now-later__tab-header-title", variant: "headingThree" }, variant === FulfillmentType.delivery
                        ? t('checkout.deliverNow')
                        : t('checkout.pickupNow')),
                    orderNowOffsetTime ? (React__default.createElement(Typography, { classes: "order-now-later__tab-header-subtitle", variant: "bodyTextTwo" },
                        variant === FulfillmentType.delivery
                            ? "".concat(t('checkout.deliveryOrderWaitingText'), " ")
                            : "".concat(t('checkout.pickupOrderWaitingText'), " "),
                        React__default.createElement("b", null, t('checkout.expectedTimeDesc', {
                            waitingTime: orderNowOffsetTime
                        })))) : null),
                React__default.createElement("input", { type: 'radio', className: "order-now-radio", checked: selectedTab === 'orderNow' }))) : null,
            isRiderNotAvailable ? (React__default.createElement(Typography, { classes: "order-now-later__rider-not-available", variant: "bodyTextTwo" }, t('checkout.riderNotAvailable'))) : null,
            !isOrderLaterDisabled ? (React__default.createElement("div", { className: classNames('order-later__tab', {
                    'order-now-later__tab--selected': selectedTab === 'orderLater'
                }), onClick: function () { return setSelectedTab('orderLater'); } },
                React__default.createElement("div", { className: "order-later__tab-header" },
                    React__default.createElement("div", null,
                        React__default.createElement(Typography, { classes: "order-now-later__tab-header-title", variant: 'headingThree' }, variant === FulfillmentType.delivery
                            ? t('checkout.deliverLater')
                            : t('checkout.pickupLater')),
                        React__default.createElement(Typography, { classes: "order-now-later__tab-header-subtitle", variant: "bodyTextTwo" }, t('checkout.chooseYourOrderDateTime'))),
                    React__default.createElement("input", { checked: selectedTab === 'orderLater', className: "order-now-radio", type: 'radio' })),
                selectedTab === 'orderLater' ? (React__default.createElement("div", { className: "order-later__tab-body" },
                    React__default.createElement("div", { className: "order-later__calendar" },
                        React__default.createElement("div", { className: "order-later__calendar-month" },
                            React__default.createElement(Typography, { classes: "order-later__calendar-month-text", variant: "bodyTextOneMain" }, selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('MMM')),
                            React__default.createElement(CalendarIcon$1, { className: "order-later__calendar-icon" })),
                        React__default.createElement("div", { className: "order-later__calendar-dates" },
                            showArrows ? (React__default.createElement(LeftOutlined, { className: "left-direction-icon", onClick: function () { return handleScroll(-48); } })) : null,
                            React__default.createElement("div", { className: "order-later__date-cards-wrapper", ref: ref }, allDates.map(function (data, index) {
                                return (React__default.createElement("div", { onClick: function () { return handleSelectDate(data); }, className: classNames('order-later__date-card', {
                                        'order-later__date-card--selected': (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('YYYY-MM-DD')) ===
                                            (data === null || data === void 0 ? void 0 : data.format('YYYY-MM-DD'))
                                    }), key: index, id: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format('YYYY-MM-DD')) ===
                                        (data === null || data === void 0 ? void 0 : data.format('YYYY-MM-DD'))
                                        ? 'active-date'
                                        : '' },
                                    React__default.createElement(Typography, { classes: "order-later__date-card-day", variant: "bodyTextTwoMain" }, data.format('ddd')),
                                    React__default.createElement(Typography, { classes: "order-later__date-card-date", variant: "bodyTextOne" }, data.format('DD'))));
                            })),
                            showArrows ? (React__default.createElement(RightOutlined, { className: "right-direction-icon", onClick: function () { return handleScroll(48); } })) : null)),
                    React__default.createElement(Tabs, { onTabChange: function () { }, classes: "order-later__slots", activeTab: 0 },
                        React__default.createElement(Tab, { classes: "order-later__slots-tab", label: 'Morning' },
                            React__default.createElement(React__default.Fragment, null, (activeMorningSlots === null || activeMorningSlots === void 0 ? void 0 : activeMorningSlots.length) ? (activeMorningSlots === null || activeMorningSlots === void 0 ? void 0 : activeMorningSlots.map(function (data) { return (React__default.createElement(Capsule, { key: data.start_time + data.end_time, label: "".concat(dayjs(data.start_time, 'HH:mm').format('h:mm A'), " - ").concat(dayjs(data.end_time, 'HH:mm').format('h:mm A')), classes: classNames('order-later__date-card-time', {
                                    'order-later__date-card-time--selected': (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.start_time) === (data === null || data === void 0 ? void 0 : data.start_time) &&
                                        (selectedTime === null || selectedTime === void 0 ? void 0 : selectedTime.end_time) === (data === null || data === void 0 ? void 0 : data.end_time)
                                }), onClick: function () { return setSelectedTime(data); } })); })) : (React__default.createElement(Typography, { classes: "order-later__slots-tab__empty-slot", variant: 'bodyTextOne' }, t('checkout.noSlotsAvailable'))))),
                        React__default.createElement(Tab, { classes: "order-later__slots-tab", label: 'Afternoon' },
                            React__default.createElement(React__default.Fragment, null, (activeAfternoonSlots === null || activeAfternoonSlots === void 0 ? void 0 : activeAfternoonSlots.length) ? (activeAfternoonSlots.map(function (data) { return (React__default.createElement(Capsule, { key: data.start_time + data.end_time, label: "".concat(dayjs(data.start_time, 'HH:mm').format('h:mm A'), " - ").concat(dayjs(data.end_time, 'HH:mm').format('h:mm A')), classes: classNames('order-later__date-card-time', {
                                    'order-later__date-card-time--selected': selectedTime === data
                                }), onClick: function () { return setSelectedTime(data); } })); })) : (React__default.createElement(Typography, { classes: "order-later__slots-tab__empty-slot", variant: 'bodyTextOne' }, t('checkout.noSlotsAvailable'))))),
                        React__default.createElement(Tab, { classes: "order-later__slots-tab", label: 'Evening' },
                            React__default.createElement(React__default.Fragment, null, (activeEveningSlots === null || activeEveningSlots === void 0 ? void 0 : activeEveningSlots.length) ? (activeEveningSlots.map(function (data) { return (React__default.createElement(Capsule, { key: data.start_time + data.end_time, label: "".concat(dayjs(data.start_time, 'HH:mm').format('h:mm A'), " - ").concat(dayjs(data.end_time, 'HH:mm').format('h:mm A')), classes: classNames('order-later__date-card-time', {
                                    'order-later__date-card-time--selected': selectedTime === data
                                }), onClick: function () { return setSelectedTime(data); } })); })) : (React__default.createElement(Typography, { classes: "order-later__slots-tab__empty-slot", variant: 'bodyTextOne' }, t('checkout.noSlotsAvailable')))))))) : null)) : null),
        React__default.createElement(Button, { classes: "order-now-continue", variant: 'solid', size: 'lg', onClick: onContinueButton, disabled: isContinueDisabled() }, t('checkout.continue'))));
}

export { OrderNowLater as default };
//# sourceMappingURL=OrderNowLater.js.map
